// A function that converts a number to exponential value with the given number of digits
export const convertToExponentialValue = (num, digits = 2) => {
    // Use the toExponential method with the digits parameter
    const [base, exponent] = num.toExponential(digits).split("e");
    // Return the product of the base and the power of 10 raised to the exponent
    return parseFloat(base) * Math.pow(10, parseInt(exponent));
};
